import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Create", -1)
const _hoisted_2 = {
  key: 0,
  class: "my-6 border rounded-lg border-neutral-100"
}
const _hoisted_3 = { class: "flex items-center justify-between p-6 border-b tabs border-neutral-100" }
const _hoisted_4 = { class: "flex items-center space-x-4" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_7 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_8 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_9 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_10 = {
  key: 0,
  class: "flex items-center justify-center mx-auto"
}
const _hoisted_11 = { class: "w-full px-6 border-t py-7" }

import { ref, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import UserLayout from '@/layouts/UserLayout.vue';
import EditButton from '@/components/buttons/EditButton.vue';
import DeleteButton from '@/components/buttons/DeleteButton.vue';
import DataTable from '@/components/partials/DataTable.vue';
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
// import MinifyPagination from '@/components/partials/MinifyPagination.vue';
import SimplePagination from "@/components/partials/SimplePagination.vue";
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import TabComponent from '@/components/partials/TabComponent.vue';
import { PlusIcon } from '@heroicons/vue/24/outline';
import RestoreButton from "@/components/buttons/RestoreButton.vue";
import { BasePageInterface } from "@/interfaces/pages/BasePageInterface";
import debounce from "lodash/debounce";
import pickBy from "lodash/pickBy";
import ActivityLogsTable from "@/views/activity-logs/ActivityLogsTable.vue"

import { filters, items } from "@/interfaces/pages/FilterPageInterface";

import FormOptions from '@/classes/Settings/FormOptions'

import assignValues from "@/helpers/assignValues"


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const showRestoreConfirmation = ref<boolean>(false);
const showRestoreSuccess = ref<boolean>(false);
const showExportSuccess = ref<boolean>(false);

const archived_count = ref(15);
const loading = ref<boolean>(false);
const showFilter = ref<boolean>(false);
const option: string = route.params.option;

const selectedId = ref<number | null>(null);

const tabs = ref();

const headers: { text: string, haveSort?: boolean }[] = [
    { text: '' },
    { text: 'Options' },
    { text: 'Date Created', haveSort: true },
];

const init = (): void => {
    loading.value = true;

    FormOptions.show(option, pickBy(filters.value))
        .then(({ data }) => {

            items.value = data.items;
            filters.value = assignValues(filters.value, data);
            loading.value = false;   

            tabs.value = [
                {
                    name: "All",
                    count: filters.value.allItemsCount,
                    tab: null,
                    allowed: true,
                },
                {
                    name: 'Archived',
                    count: filters.value.archivedItemsCount,
                    tab: "archived",
                    allowed: true
                },
            ] 
        })
}

const paginate = ({ page, rows }): void => {
    filters.value = Object.assign(filters.value, {
        page, rows
    })
    init();
};

const deleteRecord = (): void => {
    FormOptions.delete(option, selectedId.value)
        .then(() => {
            showSuccess.value = true;
            showConfirmation.value = false;
            applyFilters();
        })
        .catch((error) => console.log(error));
};

const restoreRecord = (): void => {
    FormOptions.restore(option, selectedId.value)
        .then(() => {
            showRestoreSuccess.value = true;
            showRestoreConfirmation.value = false;
            applyFilters();
        })
        .catch((error) => console.log(error));
};

const closeRestoreModal = (): void => {
    showRestoreSuccess.value = false;
};

const showRestoreModal = (item: any): void => {
    showRestoreConfirmation.value = true;
    selectedId.value = item.id;
};

const showDeleteModal = (item: any): void => {
    showConfirmation.value = true;
    selectedId.value = item.id;
};

const closeDeleteModal = (): void => {
    showSuccess.value = false;
};

const applyFilters = (search: any = null) => {
    showFilter.value = false;
    filters.value.query = search;
    init();
};

const updateTab = (currentTab: string) => {
    filters.value.tab = currentTab;
    filters.value.page = 1;
    applyFilters();
};

/**
 * WATCHERS
 */
watch(
    () => filters.value.query,
    debounce(() => {
        filters.value.page = 1;
        init();
    }, 1000)
);

onMounted(() => {
    
    init()
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: "/settings/form-options/index"
  }, {
    lowerRight: _withCtx(() => [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace(`/settings/form-options/view/${_unref(option)}/create`)))
      }, [
        _createVNode(ButtonComponent, null, {
          default: _withCtx(() => [
            _createVNode(_unref(PlusIcon), { class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon" }),
            _hoisted_1
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(TabComponent, {
                  tabs: tabs.value,
                  "onUpdate:tab": _cache[1] || (_cache[1] = (value) => updateTab(value))
                }, null, 8, ["tabs"])
              ])
            ]),
            (_unref(filters).tab != 'activity_logs')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(DataTable, {
                    headers: headers,
                    "no-action": false,
                    count: _unref(items).total,
                    hasSearch: true,
                    search: _unref(filters).query,
                    searchPlaceholder: "Search Options",
                    tableClass: "header-frm-table",
                    dataTableClass: "formOption border-0",
                    "onUpdate:searchText": _cache[2] || (_cache[2] = (value) => (_unref(filters).query = value))
                  }, {
                    body: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).data, (item) => {
                        return (_openBlock(), _createElementBlock("tr", { key: item }, [
                          _createElementVNode("td", _hoisted_6, _toDisplayString(item.id), 1),
                          _createElementVNode("td", _hoisted_7, _toDisplayString(item.name), 1),
                          _createElementVNode("td", _hoisted_8, _toDisplayString(item.created_at_formatted), 1),
                          _createElementVNode("td", _hoisted_9, [
                            (!_unref(filters).tab)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createVNode(EditButton, {
                                    onClick: ($event: any) => (_unref(router).replace(`/settings/form-options/view/${_unref(option)}/edit/${item.id}`))
                                  }, null, 8, ["onClick"]),
                                  _createVNode(DeleteButton, {
                                    onClick: ($event: any) => (showDeleteModal(item))
                                  }, null, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(filters).tab == 'archived')
                              ? (_openBlock(), _createBlock(RestoreButton, {
                                  key: 1,
                                  onClick: ($event: any) => (showRestoreModal(item))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["count", "search"])
                ]))
              : _createCommentVNode("", true),
            (_unref(filters).tab == 'activity_logs')
              ? (_openBlock(), _createBlock(ActivityLogsTable, {
                  key: 1,
                  items: _unref(items)
                }, null, 8, ["items"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(SimplePagination, {
                numRows: _unref(filters).rows,
                currentPage: _unref(items).current_page,
                "last-page": _unref(items).last_page,
                onUpdate: _cache[3] || (_cache[3] = (value) => paginate(value))
              }, null, 8, ["numRows", "currentPage", "last-page"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(ConfirmationModal, {
        typeTwo: true,
        show: showConfirmation.value,
        onCancel: _cache[4] || (_cache[4] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => (deleteRecord())),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Delete Record",
        content: "Are you sure you wish to delete this option?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (closeDeleteModal())),
        "action-text": "Close",
        title: "Record Deleted!",
        content: "Selected option has been successfully deleted!"
      }, null, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        typeTwo: true,
        show: showRestoreConfirmation.value,
        onCancel: _cache[7] || (_cache[7] = ($event: any) => (showRestoreConfirmation.value = false)),
        onConfirm: _cache[8] || (_cache[8] = ($event: any) => (restoreRecord())),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Restore Record",
        content: "Are you sure you wish to restore this option?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showRestoreSuccess.value,
        onConfirm: _cache[9] || (_cache[9] = ($event: any) => (closeRestoreModal())),
        "action-text": "Close",
        title: "Record Restored!",
        content: "Selected option has been successfully option!"
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})